import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { resetPasswordSchema } from "../utils/validations";
import Button from "../components/common/Button";
import TextField from "../components/common/TextField";
import { useResetPasswordMutation } from "../store";
import Logo from "../components/common/Logo";

interface ResetPasswordData {
  password: string;
  confirmPassword: string;
}

const ResetPassword = () => {
  const [resetPassword, { isLoading }] = useResetPasswordMutation();
  const [email, setEmail] = useState<string>("");
  const [token, setToken] = useState<string>("");
  const navigate = useNavigate();

  useEffect(() => {
    // Get code from the query string
    const urlParams = new URLSearchParams(window.location.search);
    const emailParam = urlParams.get("email");
    const codeParam = urlParams.get("code");
    if (emailParam) {
      setEmail(emailParam);
    }
    if (codeParam) {
      setToken(codeParam);
    }
  }, [navigate]);

  const handleSubmitForm = async (values: ResetPasswordData) => {
    const data = {
      email,
      token,
      password: values.password,
    };
    const result = await resetPassword(data);
    if (!result.error && result.data) {
      navigate("/auth/login"); // TODO : make routes in config no hard code
    }
  };

  const {
    values,
    errors,
    touched,
    isSubmitting,
    handleChange,
    handleBlur,
    handleSubmit,
  } = useFormik<ResetPasswordData>({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validationSchema: resetPasswordSchema,
    onSubmit: handleSubmitForm,
  });

  return (
    <div className="w-full flex min-h-screen">
      <div className="w-1/2 h-full flex flex-col items-center mt-12 p-4">
        <form className="mx-auto w-3/5 flex flex-col items-center gap-3">
          <Logo />
          <TextField
            id="password"
            value={values.password || ""}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched}
            errors={errors}
            placeholder="Mot de passe"
            hideable
          />
          <TextField
            id="confirmPassword"
            value={values.confirmPassword || ""}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched}
            errors={errors}
            placeholder="Confirmer le mot de passe"
            hideable
          />
          <Button
            className="w-1/2 justify-center font-bold py-2 bg-primary rounded text-white"
            disabled={isSubmitting || isLoading}
            type="submit"
            onClick={handleSubmit}
          >
            Envoyer
          </Button>
        </form>
      </div>
      <img
        className="w-1/2 h-full object-cover"
        src="/assets/images/auth-banner.jpg"
      />
    </div>
  );
};

export default ResetPassword;
